import type { ReactNode } from "react";

interface CardProps {
  title?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function Card({ title, action, children, className = "" }: CardProps) {
  return (
    <section
      className={`rounded-xl border border-border-subtle bg-surface-card/70 p-4 ${className}`}
    >
      {(title || action) && (
        <div className="mb-3 flex items-center justify-between">
          {title ? (
            <h2 className="text-base font-semibold tracking-tight text-fg-strong">
              {title}
            </h2>
          ) : (
            <span />
          )}
          {action ? <div>{action}</div> : null}
        </div>
      )}
      {children}
    </section>
  );
}
